import style from './header.module.scss';
import { useNavigate } from "react-router-dom";


export default function Header() {
    const navigate = useNavigate();

    return (
        <header className={style.HeaderMenu}>
            <section className={style.HeaderSection}>
                <button className={style.HeaderIconContainer}>
                    <i className={`${style.HeaderMenuIcon} fa-solid fa-bars`}></i>
                </button>
                <div>
                    <p 
                    className={style.HeaderMenuRigh} 
                    onClick={() => navigate('/')}
                    >
                        WORDLE
                    </p>
                </div>
            </section>
        </header>
    )
}